import { makeAutoObservable } from 'mobx'
import socket, { Socket, SocketStatus } from 'socket.io-react'
import config from '~/config'
import authenticationStore from './authenticationStore'
import { register } from './support'

export class SocketStore {

  constructor() {
    makeAutoObservable(this)
  }

  public socketStatus: SocketStatus = 'disconnected'

  public connect(authToken: string | null) {
    this.disconnect()
    if (authToken == null) { return }

    socket.connect(config.api.socketURI, {
      query:      {token: authToken},
      transports: ['websocket', 'polling'],
    })
  }

  public disconnect() {
    socket.disconnect()
  }

  //------
  // Status

  public init() {
    socket.addStatusChangeListener(this.onSocketStatus)
    authenticationStore.on('logout', this.onLogOut)
    document.addEventListener('visibilitychange', this.onVisibilityChange)

    window.addEventListener('rn-background', this.rnBackground)
    window.addEventListener('rn-foreground', this.rnForeground)
  }

  private onSocketStatus = (_: Socket, status: SocketStatus) => {
    this.socketStatus = status
  }

  //------
  // App events

  public onLogOut() {
    socket.disconnect()
  }

  public onDeactivate() {
    socket.disconnect()
  }

  private onVisibilityChange = () => {
    // eslint-disable-next-line
    console.log('In onVisibilityChange', document.hidden)

    if (document.hidden) {
      socket.disconnect()
    } else if (authenticationStore.authToken != null) {
      this.connect(authenticationStore.authToken)
    }
  }

  private rnBackground = () => {
    // eslint-disable-next-line
    console.log('App gaat op achtergrond, socket disconnecten')

    socket.disconnect()
  }

  private rnForeground = () => {
    // eslint-disable-next-line
    console.log('In rnForeground')

    if (authenticationStore.authToken != null) {
      // eslint-disable-next-line
      console.log('App gaat op voorgrond, socket verbinden')

      this.connect(authenticationStore.authToken)
    }
  }
}

const socketStore = register(new SocketStore())
export default socketStore